import { createWidget } from "@opendash/plugin-monitoring";
import React from "react";
import { ConfigInterface } from "./types";

export default createWidget<ConfigInterface>({
  type: "opendash-widget-hgtablesum",
  meta: {},
  displayComponent: React.lazy(() => import("./component")),
  settingsComponent: React.lazy(() => import("./settings")),

  dataItems: {
    select: "item",
    min: 1,
    max: 1,
  },

  dataFetching: {
    live: true,
    history: true,
    historyRequired: true,
  },

  presets: [
    {
      label: "greis:widgets.table_sum.title",
      description: "greis:widgets.table_sum.description",
      imageLink: require("./preset.png"),
      tags: ["H&G"],
      layout: [6, 24],
      widget: {
        config: {
          _history: {
            historyType: "relative",
            value: 3,
            unit: "month",
          },
        },
      },
    },
  ],
});
